import React, { useContext, useState } from 'react';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';

import { approveSaleFinalisation } from 'PrivateAPI';

import { PAYMENT_PAGE_EVENTS } from 'Utilities/analytics/analyticsPaymentPage';
import { captureExceptionWithTeam } from 'Utilities/captureException/captureExceptionWithTeam';
import { TEAM } from 'Utilities/constants';
import useUrlVRM from 'Utilities/hooks/useUrlVRM';

import { FiguresBox } from '../components/FiguresBox/FiguresBox';
import FinanceApplicable from '../components/FiguresBox/FinanceApplicable/FinanceApplicable';
import NoFinanceApplicable from '../components/FiguresBox/NoFinanceApplicable/NoFinanceApplicable';
import LocalTexts from '../Payments.text.json';
import { PaymentViewProps } from '../Payments.types';
import { PaymentContext } from '../PaymentsContext';

import styles from './PaymentAccepted.scss';

const LocalT = new MDText(LocalTexts.payments.acceptedView);

const PaymentAccepted = ({ actions }: PaymentViewProps) => {
  const { valuationRef, vrm } = useUrlVRM({ optimisticReturn: true });
  const { paymentState: { financingAmount } } = useContext(PaymentContext);

  const [loading, setLoading] = useState<boolean>(false);

  const acceptOffer = async () => {
    if (!valuationRef) {
      captureExceptionWithTeam('[PaymentAccepted] User cannot accept payment, valuationRef not found.', TEAM.PAYMENTS_FE, {
        level: 'critical',
      });

      return;
    }

    try {
      setLoading(true);
      await approveSaleFinalisation(valuationRef);
      actions.showPendingView();
    } catch (err) {
      setLoading(false);
      captureExceptionWithTeam(err, TEAM.PAYMENTS_FE);
    }
  };

  return (
    <div className={styles.paymentAcceptedWrapper}>
      <FiguresBox
        buttons={
          <>
            <Button
              fullWidth
              disabled={loading}
              icon="chevron"
              label={`${LocalT.translate('buttons.accept')}`}
              loading={loading}
              onClick={() => {
                acceptOffer();
                PAYMENT_PAGE_EVENTS.VEHICLE_PAYMENT_RECEIVE_PAYMENT_BUTTON_CLICKED({
                  buttonLabel: `${LocalT.translate('buttons.accept')}`,
                  vrm,
                });
              }}
            />
            <Button
              fullWidth
              disabled={loading}
              label={`${LocalT.translate('buttons.decline')}`}
              onClick={() => {
                actions.showEnterView();
                PAYMENT_PAGE_EVENTS.VEHICLE_PAYMENT_BACK_BUTTON_CLICKED({
                  buttonLabel: `${LocalT.translate('buttons.decline')}`,
                  vrm,
                });
              }}
              variant="secondary"
            />
          </>
        }
        content={
          <>
            {financingAmount ? (
              <FinanceApplicable />
            ) : (
              <NoFinanceApplicable />
            )}
          </>
        }
        icon="info"
        title={`${LocalT.translate('title')}`}
      />
    </div>
  );
};

export { PaymentAccepted };
